import makeStyles from "@mui/styles/makeStyles";
import { Bold, Regular } from "../../utils";
export const PropertyStylesParent = makeStyles((theme) => ({
    tabtitle: {
        fontSize:"0.75rem",
        color: '#4E5A6B',
        fontFamily: Bold,
    },
    tabtitle1: {
        fontSize:"0.75rem",
        color: '#5078E1',
        fontFamily: Bold,
    },
    subtabtitle: {
        fontSize:"0.75rem",
        color: '#4E5A6B',
        fontFamily: Regular,
    },
    subtabtitle1: {
        fontSize:"0.75rem",
        color: '#5078E1',
        fontFamily: Regular,
    },
    selectBack1: {
        backgroundColor: 'white',
        display: 'flex',
        alignItems: 'center',
        padding: '10px 32px',
        // borderTopLeftRadius: "12px",
        // borderTopRightRadius: "12px"
    },
    selectBack: {
        display: 'flex',
        alignItems: 'center',
        padding: '12px',
    },
}))